import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-simpletextinputdialog',
  standalone: false,
  templateUrl: './simpletextinputdialog.component.html',
  styleUrl: './simpletextinputdialog.component.css'
})
export class SimpleTextInputDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<SimpleTextInputDialogComponent>>(MatDialogRef);
  private auth = inject(AuthService);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup;

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      textData: new UntypedFormControl('', Validators.required)
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

  async submit() {
    if (this.form.invalid) {
      return;
    }
    await this.data.callback(this.form.value.textData);
    this.dialogRef.close(true);
  }
}
